import { render } from "./BackgroundCarousel.vue?vue&type=template&id=b8c03f54&scoped=true"
import script from "./BackgroundCarousel.vue?vue&type=script&lang=js"
export * from "./BackgroundCarousel.vue?vue&type=script&lang=js"

import "./BackgroundCarousel.vue?vue&type=style&index=0&id=b8c03f54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c03f54"]])

export default __exports__